import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import type { Order } from "@/api/order/_models/Order";
import { OrderListSystemChip } from "@/features/order/order-list/order-list-system-chip/OrderListSystemChip";
import { toOrderListSystemSummaryList } from "@/features/order/order-list/toOrderListSystemSummaryList";
import { ListGridExpandedSection } from "@/components/list-grid/ListGridExpandedSection";

interface OrderListExpandedExternalSystemsProps {
  order: Order;
}

/** The expanded order's External systems section: per system, its chip, what it last reported and its number for the order. */
export const OrderListExpandedExternalSystems = (props: OrderListExpandedExternalSystemsProps) => {
  const { order } = props;
  const summaries = toOrderListSystemSummaryList(order);

  return (
    <ListGridExpandedSection
      emptyText="No system knows this order yet."
      isEmpty={summaries.length === 0}
      title="External systems"
    >
      <Box
        sx={{
          alignItems: "center",
          columnGap: 2,
          display: "grid",
          gridTemplateColumns: "max-content minmax(0, 1fr) max-content",
          rowGap: 1,
        }}
      >
        {summaries.map((summary) => (
          <Box
            key={summary.system}
            sx={{ display: "contents" }}
          >
            <Box sx={{ justifySelf: "start" }}>
              <OrderListSystemChip system={summary.system} />
            </Box>
            <Typography
              noWrap
              variant="body2"
            >
              {summary.status?.status ?? "—"}
            </Typography>
            <Typography
              color="text.secondary"
              noWrap
              sx={{ fontFamily: "monospace" }}
              variant="body2"
            >
              {summary.reference ?? "—"}
            </Typography>
          </Box>
        ))}
      </Box>
    </ListGridExpandedSection>
  );
};
